import { useI18n } from '../../i18n/useI18n.js'

import { PillBadge } from '../PillBadge/PillBadge.jsx'

import styles from './StatusBadge.module.scss'
/**
 * StatusBadge — availability status as a localized, styled inline badge.
 *
 * Uses the shared `--bim-data-value-size` CSS var for its font-size so that
 * it stays visually consistent with DataItem values when rendered in the
 * same tile context.
 *
 * The `size` prop injects `--bim-data-*` vars on the badge element itself,
 * so it can be sized independently of any ancestor DataGrid.
 *
 * @param {object}   props
 * @param {string}   props.status               - Availability status string (e.g. 'available', 'sold')
 * @param {'small'|'normal'|'large'} [props.size] - Typography scale; omit to inherit from ancestor
 * @param {string}  [props.className]            - Extra class on root element
 */
export function StatusBadge({ status, size = 'small', className }) {
  const { t } = useI18n()

  if (!status) return null

  const labelClass = `status${status.charAt(0).toUpperCase() + status.slice(1)}`

  return (
    // <span
    //   style={sizeStyle}
    //   className={[
    //     styles.badge,
    //     styles[labelClass],
    //     className,
    //   ].filter(Boolean).join(' ')}
    // >
    //   {t(`status.${s}`)}
    // </span>
    <PillBadge
      value={t(`status.${status}`)}
      size={size}
      className={[styles[labelClass], className].filter(Boolean).join(' ')}
    />
  )
}
